import {
    AbstractControl
} from "@angular/forms";
import { StringUtil } from "@shopliftr/common-js/data";
import {
    Observable,
    debounceTime,
    distinctUntilChanged,
    of,
    throwError
} from "rxjs";
import { ICheckChangesComponent } from "./interfaces/check-changes-component";
import { NotificationService } from "../notification/services/notification.service";
import { InvalidParametersException } from "../exceptions/invalid-parameters-exception";

/**
 * Utility functions used when working with forms
 */
export class FormUtil {

    static readonly DEFAULT_DEBOUNCE_TIME = 300;

    static readonly DEFAULT_PROMPT_MESSAGE = "Are you sure you want to discard changes?";

    static readonly DEFAULT_DIALOG_TITLE = "Unsaved Changes";

    /**
     * This will returned a debounced form control valueChanges observable
     *
     * If debounce time value is not provided it will default to 300;
     */
    static debounceValueChanges$(formControl: AbstractControl, debounceTimeValue?: number): Observable<any> {

        return formControl.valueChanges.pipe(
            debounceTime(debounceTimeValue ?? this.DEFAULT_DEBOUNCE_TIME),
            distinctUntilChanged()
        );
    }

    /**
     * Returns true if the form value is undefined, null, or any empty string
     */
    static emptyValue(value: unknown): boolean {

        return StringUtil.emptyString(value as string, true);
    }

    /**
     *  If the form is changed it will prompt the user to confirm that they wish the navigate away.
     */
    static handleFormLeave$(component: ICheckChangesComponent, notificationService: NotificationService): Observable<boolean> {

        if (!component) {
            return throwError(() => new InvalidParametersException("component is required"));
        }

        if (!notificationService) {
            return throwError(() => new InvalidParametersException("notificationService is required"));
        }
        if (component.skipCheck) {
            // Skip the check and proceed
            return of(true);
        }

        if (component.isChanged || component.form?.isChanged) {
            // the component or form is changed, so prompt the user
            return notificationService.displayConfirmation$(
                component.changedConfirmMessage ?? FormUtil.DEFAULT_PROMPT_MESSAGE,
                { title: FormUtil.DEFAULT_DIALOG_TITLE }
            );
        }
        else {
            // No form has not changes, so proceed
            return of(true);
        }
    }
}
